import { useState } from "preact/hooks";
import headerStyles from "./header.module.css";
import mobileStyles from "./mobile-menu.module.css";
import { Chevron } from "./chevron";
import expandStyles from "./expandMenu.module.css";
import { LinkContent } from "./linkContent";
import { Categories } from "./categories";
import { NewsLetter } from "./newsletter";
import { showExpandButton } from "./helpers";

export function MobileMenu({ meganav, showMobileMenu }) {
  const [internalMeganav, setInternalMeganav] = useState(meganav);
  const [subMenuOpen, setSubMenuOpen] = useState(false);

  function open(id, state) {
    setSubMenuOpen(state);
    setInternalMeganav(
      internalMeganav.map((menu) => {
        if (menu.id === id) {
          return {
            ...menu,
            isOpen: state,
          };
        }
        return {
          ...menu,
        };
      })
    );
  }

  return (
    <div
      class={`${mobileStyles["header-nav"]} ${
        showMobileMenu ? mobileStyles["header-nav--active"] : ""
      }`}
    >
      <nav>
        <ul class={mobileStyles["header-nav__links"]}>
          {internalMeganav.map((link) => (
            <li
              key={link.id}
              class={`${
                subMenuOpen && !link.isOpen
                  ? `${mobileStyles["header-nav__link-wrapper"]}`
                  : `${mobileStyles["header-nav__link-wrapper"]} ${mobileStyles["header-nav__link-wrapper--active"]}`
              }`}
            >
              <div
                class={`${headerStyles["link"]} ${
                  subMenuOpen ? "" : headerStyles["link--active"]
                }`}
              >
                {!showExpandButton(link) && (
                  <a href={link.url} class={headerStyles["link-heading"]}>
                    {link.name}
                  </a>
                )}

                {showExpandButton(link) && (
                  <div class={headerStyles["link-container"]}>
                    <a href={link.url} class={`${headerStyles["link-heading"]}`}>
                      {link.name}
                    </a>
                    <button
                      type="button"
                      onClick={() => open(link.id, !subMenuOpen)}
                      class={headerStyles["chevron"]}
                    >
                      <Chevron />
                    </button>
                  </div>
                )}
              </div>

              {link.hasMegaMenu && <MobileMegaNav link={link} open={open} />}

              {!link.hasMegaMenu && link.children.length > 0 && (
                <MobileExpandMenu link={link} open={open}>
                  <ul>
                    {link.children.map((child) => (
                      <li class={mobileStyles["link"]}>
                        <a href={child.url}>{child.name}</a>
                      </li>
                    ))}
                  </ul>
                </MobileExpandMenu>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

function MobileMegaNav({ link, open }) {
  return (
    <div
      class={`${mobileStyles["mega-menu"]} ${
        link.isOpen ? mobileStyles["mega-menu--active"] : ""
      }`}
    >
      <button
        type="button"
        onClick={() => open(link.id, false)}
        class={`${mobileStyles["back-button"]} mt-3 mb-2`}
      >
        <Chevron css={{ transform: "rotate(90deg)" }} /> {globalThis.translations.back || "Back"}
      </button>

      <LinkContent link={link} />
      <Categories link={link} />
      <NewsLetter link={link} />
    </div>
  );
}

// todo move all others to use this
function MobileExpandMenu({ link, open, children }) {
  return (
    <div
      class={`${expandStyles["expand-menu"]} ${
        link.isOpen ? expandStyles["expand-menu--active"] : ""
      }`}
    >
      <button
        type="button"
        onClick={() => open(link.id, false)}
        class={`${mobileStyles["back-button"]} mt-3 mb-2`}
      >
        <Chevron css={{ transform: "rotate(90deg)" }} /> {globalThis.translations.back || "Back"}
      </button>
      {children}
    </div>
  );
}
